import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import FormRouter from "routes/FormRouter";
import "./index.css";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

rootElement.addEventListener("touchstart", (e) => {
  // is not near edge of view, exit
  if (
    e.touches[0].screenX > 20 &&
    e.touches[0].screenX < window.innerWidth - 20
  )
    return;

  // prevent swipe to navigate gesture
  e.preventDefault();
});

const renderAppDev = () => (
  <React.StrictMode>
    <FormRouter />
  </React.StrictMode>
);
const renderAppPro = () => <FormRouter />;

root.render(
  process.env.REACT_APP_ENV === "production" ? renderAppPro() : renderAppDev(),
);

reportWebVitals();
